import { Skeleton, Typography } from 'antd';
import { useGetCargosSummary } from 'api/cargos/use-get-cargos-summary';
import type { IWhInfoCargoesTotalsProps } from './types';
import styles from './wh-info-cargoes-totals.module.scss';

export const WhInfoCargoesTotals: React.FC<IWhInfoCargoesTotalsProps> = (props) => {
  const { filters, title } = props;
  const { data: totals, isLoading } = useGetCargosSummary({ filters, includeFromStatuses: true });

  if (isLoading) {
    return <Skeleton.Input size='small' style={{ width: 200 }} />;
  }

  if (!totals || totals.count === 0) {
    return null;
  }

  return (
    <div className={styles.totals}>
      <Typography.Text>
        <strong>{title}</strong>: LDM {totals.totalLDM || 0}, Weight {totals.totalWeight || 0}, Count{' '}
        {totals.count || 0}
      </Typography.Text>
    </div>
  );
};
